<template>
  <div class="approve-upload">
    <Upload
      ref="upload"
      :action="action"
      :headers="headers"
      :file-list.sync="fileList"
      list-type="text"
      :on-remove="handleRemove"
      :on-success="success"
      :limit="limit"
      :on-exceed="exceed"
      :accept="accept && accept.toString()"
      :before-upload="beforeUpload"
      :http-request="httpRequest"
      :on-preview="previewFile"
    >
      <div v-if="(type !== 'img' && !hideTips)" slot="tip" class="Upload__tip">只能上传jpg/png/gif/jpeg/xls/xlsx/doc/docx/pdf文件，且单个文件不能超过50MB，文件数量不超过5个</div>
      <div>
        <el-button size="small" class="arrpove-upload-btn" type="">
          <img
            style="width: 14px; height: 14px"
            src="@/assets/upload.png"
            alt=""
          >
          <span>上传附件</span></el-button>
      </div>
      <template v-slot:file="{file, fileType}">
        <template v-if="(fileType !== 'file')">
          <svg-icon v-if="file.url" icon-class="img-close" @click="deleteFile(file)" />
          <el-image v-if="file.url" slot="file" :src="file.url" @click.native="previewFile(file)" />
          <div v-else v-loading="true" element-loading-spinner="el-icon-loading" class="image-slot image-loading" />
        </template>
        <div v-else v-loading="!file.url" class="file-upload" element-loading-spinner="el-icon-loading">
          <div class="file-item" @click="previewFile(file)">
            <div class="file">
              <span class="name">{{ file.name }}</span>
            </div>
            <svg-icon v-if="file.url" icon-class="upload-success" />
          </div>
          <div v-if="file.url" class="upload-delete" @click="deleteFile(file)">
            <svg-icon icon-class="upload-delete" />
          </div>
        </div>
      </template>
    </Upload>
  </div>
</template>

<script>
import Upload from './upload/upload'
import { getToken } from '@/utils/auth'
import { uploadFiles } from '@/api/common'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    Upload
  },
  props: {
    path: {
      type: String,
      default: '/externalApplication/upload'
      // default: '/file/upload'
    },
    actionPath2: {
      // 自定义的上传地址
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    accept: {
      type: Array,
      default: () => []
    },
    allowSize: {
      type: Number,
      default: 50 * 1024 // 50M
    },
    hideTips: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number, // 最多上传文件数
      default: 5
    }
  },
  data() {
    return {
      headers: {
        'S-Token': getToken()
      },
      fileList: [], // 预览列表
      action: this.actionPath(),
      disabled: false
    }
  },
  mounted() {
    let headers = {
      'S-Token': getToken()
    }
    if (this.$isInFrame) {
      headers = {
        'X-Token': getToken()
      }
    }
    const isConsole = sessionStorage.getItem('isConsole')
    if (isConsole) {
      headers = {
        'C-Token': getToken()
      }
    }
    if (this.$isInKa) {
      headers = {
        'sso-Token': getToken()
      }
    }
    this.headers = headers
  },
  methods: {
    initDefault(value) {
      this.fileList = value
      console.log('this.fileList', this.fileList)
    },
    async httpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('source', 'bpm')
      const res = await uploadFiles(formData, this.headers, progressEvent => {
        const complete = parseInt(
          ((progressEvent.loaded / progressEvent.total) * 100) | 0,
          10
        )
        file.onProgress({ percent: complete })
      })
      if (res.code === 511) {
        this.$message.warning(res.message)
        return
      }
      if (res.code === 200 && res.data) {
        console.log('this.$refs.upload.fileList', this.$refs.upload.fileList)
        // this.$refs.upload.fileList.forEach((item) => {
        //   if (item.uid === file.file.uid) {
        //     item.url = res.data
        //   }
        // })
        this.fileList.push({
          name: file.file.name,
          url: res.data
        })
        const uploadFileList = this.fileList.filter((item) => item.url && item.url.startsWith('https'))
        const submitList = uploadFileList.map((item) => {
          return {
            name: item.name,
            url: item.url
          }
        })
        this.$emit('input', submitList)
      }
    },
    // 预览图片
    previewFile(file) {
      console.log(file)
      if (file.url) {
        this.$fileView.openFile(file)
      } else {
        console.log('还未上传完成')
      }
    },
    actionPath() {
      return this.actionPath2
        ? this.actionPath2
        : process.env.VUE_APP_BASE_API + this.path
    },
    success(res, file, fileList) {
      // if (res.code === 511) {
      //   this.$message.warning(res.message)
      //   return
      // }
      // const list = fileList.map((item) => {
      //   console.log(item)
      //   return {
      //     name: item.name,
      //     url: item.response && item.response.data || item.url
      //   }
      // })
      // this.$emit('input', list)
    },
    preview(file) {
      console.log(file, 'file')
      const arr = file.name.split('.')
      file.suffix = arr[arr.length - 1].toLowerCase()
      // 图片预览当前页面弹窗展示
      if (file.suffix === 'png' || file.suffix === 'jpg' || file.suffix === 'jpeg' || file.suffix === 'gif') {
        this.dialogVisible = true
        this.dialogImageUrl =
        file.code === 200 && file.response.data ? file.response.data : file.url
      } else {
      // 文件预览
        window.open(file.url)
      }
    },
    deleteFile(file) {
      this.fileList = this.fileList.filter((item) => item.url !== file.url)
      this.$emit('input', cloneDeep(this.fileList))
    },
    handleRemove(file, fileList) {
      const newFileList = fileList.map((item) => {
        return {
          name: item.name,
          url: item.response && item.response.data || item.url
        }
      })
      this.fileList = cloneDeep(newFileList)
      this.$emit('input', newFileList)
    },
    // 清空图片展示
    clearFileList() {
      if (this.$refs.upload) {
        this.fileList = []
        this.$refs.upload.uploadFiles = []
      }
    },
    beforeUpload(file) {
      console.log(file)
      // 附件格式限制
      const arr = file.name.split('.')
      file.suffix = arr[arr.length - 1].toLowerCase()
      let allowType = ['jpg', 'png', 'gif', 'jpeg', 'xls', 'xlsx', 'doc', 'docx', 'pdf']
      if (this.type === 'img') {
        allowType = ['jpg', 'png', 'gif', 'jpeg']
      }
      if (!allowType.includes(file.suffix)) {
        this.$message.error(this.type === 'img' ? '仅支持jpg/png/gif/jpeg' : '仅支持jpg/png/gif/jpeg/xls/xlsx/doc/docx/pdf')
        return false
      }
      // 附件大小限制
      if (this.allowSize) {
        const b = file.size
        const isLtSize = b > this.allowSize * 1024
        const sizeStr =
          this.allowSize >= 1024
            ? `${Math.round((this.allowSize / 1024) * 100) / 100}MB`
            : `${this.allowSize}KB`
        if (isLtSize) {
          this.$message.error(`附件不能超过${sizeStr}哦`)
          return false
        }
      }
    },
    exceed(file, fileList) {
      this.$message.error(`附件个数不能超过${this.limit}个哦`)
    }
  }
}
</script>

<style lang="scss" scoped>
  .approve-upload {
    /deep/.arrpove-upload-btn {
      >span {
        display: inline-flex;
        img {
          margin-right: 2px;
        }
      }
    }
    /deep/ .el-upload-list_file {
      padding-top: 8px;
    }
    .file-upload {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      .file-item {
        flex: 1;
        padding: 7px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        border-radius: 4px;
        background-color: #F2F3F5;
        .file {
          display: flex;
          align-items: center;
          .name {
            line-height: 22px;
            color: #1D2129;
            font-size: 14px;
          }
        }
      }
      .upload-delete {
        padding: 0px 8px;
        cursor: pointer;
      }
    }
  }
 /deep/.el-upload-list__item{
      // display: contents !important;
      // width: 500px!important;
      transition: none;
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      margin-right: 10px;
      img {
        display: block;
        width: 50px;
        height: 50px;
        border-radius: 4px;
        cursor: pointer;
        }
        width: 50px;
        height: 50px;
        float: left;
        margin-bottom: 10px;
      &.is-success {
        width: 50px;
        height: 50px;
        float: left;
        margin-bottom: 10px;
      }
      &.is-uploading {
        width: 50px;
        height: 50px;
        float: left;
        margin-bottom: 10px;
      }
      .image-slot {
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
      .image-loading {
        border: 1px solid #f1f1f1;
        border-radius: 4px;
        .el-loading-spinner {
          margin-top: -14px;
        }
      }
      svg {
        position: absolute;
        right: -4px;
        top: -4px;
        z-index: 5;
        cursor: pointer;
      }
    }
//   .img-preview{
//       width: 100%;
//       max-height: 700px;
//       overflow:scroll;
//       img{
//         max-width: 100%!important;
//       }
//     }
</style>
